export default __webpack_public_path__ + "static/media/requestAttendance.266040f6.svg";